export type City = {
  slug: string;
  name: string;
  region: string;
  lat: number;
  lng: number;
  intro?: string;
};

export const cities: Record<string, City> = {
  montclair: {
    slug: "montclair",
    name: "Montclair",
    region: "CA",
    lat: 34.0775,
    lng: -117.6897,
    intro:
      "Locally based in Montclair, SimpleTech delivers proactive managed IT — 24/7 monitoring, cybersecurity, help desk, and rapid on-site support for Montclair businesses.",
  },
  claremont: {
    slug: "claremont",
    name: "Claremont",
    region: "CA",
    lat: 34.0967,
    lng: -117.7198,
  },
  upland: {
    slug: "upland",
    name: "Upland",
    region: "CA",
    lat: 34.0975,
    lng: -117.6484,
  },
  ontario: {
    slug: "ontario",
    name: "Ontario",
    region: "CA",
    lat: 34.0633,
    lng: -117.6509,
  },
  "rancho-cucamonga": {
    slug: "rancho-cucamonga",
    name: "Rancho Cucamonga",
    region: "CA",
    lat: 34.1064,
    lng: -117.5931,
  },
};

export const cityList = Object.values(cities);

export function getCity(slug: string): City | undefined {
  return cities[slug];
}
